export default () => {
    const accordionButtons = document.querySelectorAll('.wch-accordion');
    let i;

    for (i=0; i < accordionButtons.length; i++) {
        accordionButtons[i].addEventListener("click", function() {
            this.classList.toggle("accordion-tab-active");
            let accordionContent = this.nextElementSibling;
            const svg = this.firstElementChild;

            if (accordionContent.style.maxHeight) {
                accordionContent.style.maxHeight = null;
                svg.style.transform = "rotate(0)"
            } else {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
                svg.style.transform = "rotate(180deg)"
            }
        })
    }
}